<template>
    <v-container class="services grid-list-lg">
        <h3 class="align-left mb-4">Сведения о транспортном средстве</h3>
        <v-layout row wrap align-start>
            <v-flex xs12 sm6 md4 lg3 py-0 class="field-block gos-number-block">
                <span class="alert-russian-symbols" v-if="!symbolsRussian">Могут использоваться только русские буквы</span>
                <v-text-field
                    :label="placeholder"
                    v-model="value.licensePlate"
                    :rules="[rules.required, rules.number, rules.minCount]"
                    validate-on-blur
                    required
                    v-mask="'G QQQ GG QQQ'"
                    @focus="onFocusTextField"
                    @blur="onBlurTextField"
                    @input="onInputGosNumber"
                    ref="gosNumberInput"
                    class="field-upper-text"
                />
            </v-flex>
            <v-flex>
                <v-btn
                    class="button next-button block mt-1"
                    :loading="numberInfoLoading"
                    @click="requestsByNumber"
                >
                    Найти
                </v-btn>
            </v-flex>
        </v-layout>
        <v-layout row wrap align-end>
            <v-flex xs12 sm6 md4 lg3 py-0>
                <v-text-field
                    v-model="value.mark"
                    :rules="[rules.required]"
                    label="Марка"
                    validate-on-blur
                    required
                />
            </v-flex>
            <v-flex xs12 sm6 md4 lg3 py-0>
                <v-text-field
                    v-model="value.model"
                    :rules="[rules.required]"
                    label="Модель"
                    validate-on-blur
                    required
                />
            </v-flex>
            <v-flex xs12 sm6 md4 lg3 py-0>
                <v-select
                    v-model="value.type"
                    :items="types"
                    label="Тип ТС"
                    return-object
                    single-line
                ></v-select>
            </v-flex>
            <v-flex xs12 sm6 md4 lg3 py-0>
                <v-text-field
                    v-model="value.yearIssue"
                    label="Год выпуска"
                    :rules="[rules.required, rules.yearIssue]"
                    mask="####"
                    validate-on-blur
                    required
                />
            </v-flex>
            <v-flex xs12 sm6 md4 lg3 py-0>
                <v-text-field
                    v-model="value.color"
                    label="Цвет"
                    :rules="[rules.required]"
                    validate-on-blur
                    required
                />
            </v-flex>
            <v-flex xs12 sm6 md4 lg3 py-0>
                <v-checkbox
                    class="service-transport-check-box"
                    style="margin-top: 0; height: 25px;"
                    label='Отсутствует VIN'
                    v-model="value.noVin"
                />
                <v-text-field
                    v-model="value.vin"
                    :rules="[rules.vin]"
                    v-mask="'VVVVVVVVVVVVVVVVV'"
                    label="Введите VIN"
                    @input="vinOtoZeroAndUpperCase(value.vin)"
                    :disabled="value.noVin"
                />
            </v-flex>
            <v-flex xs12 sm6 md4 lg3 py-0>
                <v-checkbox
                    class="service-transport-check-box"
                    style="margin-top: 0; height: 25px;"
                    label='Отсутствует номер кузова'
                    v-model="value.noBodyNumber"
                />
                <v-text-field
                    v-model="value.bodyNumber"
                    :rules="[rules.bodyNumber]"
                    v-mask="'NNNNNNNNNNNNNNNNN'"
                    @input="value.bodyNumber = stringToUpper(value.bodyNumber)"
                    label="Номер кузова/прицепа/кабины"
                    :disabled="value.noBodyNumber"
                />
            </v-flex>
            <v-flex xs12 sm6 md4 lg3 py-0>
                <v-checkbox
                    class="service-transport-check-box"
                    style="margin-top: 0; height: 25px;"
                    label='Отсутствует номер шасси'
                    v-model="value.noChassisNumber"
                />
                <v-text-field
                    v-model="value.chassisNumber"
                    :rules="[rules.chassisNumber]"
                    v-mask="'NNNNNNNNNNNNNNNNN'"
                    @input="value.chassisNumber = stringToUpper(value.chassisNumber)"
                    label="Номер шасси/рамы"
                    :disabled="value.noChassisNumber"
                />
            </v-flex>
            <v-flex xs12 sm6 md4 lg3 py-0>
                <v-text-field
                    v-model="value.engine"
                    :rules="[rules.required]"
                    label="Номер и модель двигателя"
                    required
                />
            </v-flex>
            <v-flex xs12 sm6 md4 lg3 py-0>
                <v-text-field
                    v-model="value.pts.location"
                    :rules="[rules.required]"
                    label="Кем выдан ПТС"
                    validate-on-blur
                    required
                ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md4 lg3 py-0>
                <v-text-field
                    v-model="value.pts.seriesNumber"
                    :rules="[rules.required, rules.pts]"
                    @paste="removeSpacesOnPaste($event, value.seriesNumber)"
                    mask="##RR ######"
                    return-masked-value
                    label="Серия и номер ПТС"
                    validate-on-blur
                    required
                ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md4 lg3 py-0>
                <osago-date
                    label="Дата выдачи ПТС"
                    v-model="value.pts.date"
                    :max="dateToday"
                    :isHideMobile="true"
                />
            </v-flex>
        </v-layout>
        <v-layout wrap row>
            <v-flex xs12>
                <v-checkbox
                    v-model="value.isSrtsAndLicensePlate"
                    label="Указывать свидетельство о регистрации ТС и гос. регистрационный знак."
                    class="mt-0"
                />
            </v-flex>
        </v-layout>
        <v-layout wrap row v-if="value.isSrtsAndLicensePlate">
            <v-flex xs12 sm6 md4 lg3 py-0>
                <v-text-field
                    v-model="value.sts.seriesNumber"
                    :rules="[rules.required, rules.pts]"
                    @paste="removeSpacesOnPaste($event, value.seriesNumber)"
                    mask="##SS ######"
                    return-masked-value
                    label="Серия и номер СТС"
                    validate-on-blur
                    required
                ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md4 lg3 py-0>
                <osago-date
                    label="Дата выдачи СТС"
                    v-model="value.sts.date"
                    :max="dateToday"
                    :isHideMobile="true"
                />
            </v-flex>
            <v-flex xs12 sm12 md4 lg6 py-0>
                <v-text-field
                    v-model="value.sts.location"
                    :rules="[rules.required]"
                    label="Кем выдан СТС"
                    validate-on-blur
                    required
                ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md4 lg3 py-0 class="field-block gos-number-block">
                <span class="alert-russian-symbols" v-if="!symbolsRussian">Могут использоваться только русские буквы</span>
                <v-text-field
                    :label="placeholder"
                    v-model="value.licensePlate"
                    :rules="[rules.required, rules.number, rules.minCount]"
                    validate-on-blur
                    required
                    v-mask="'G QQQ GG QQQ'"
                    @focus="onFocusTextField"
                    @blur="onBlurTextField"
                    @input="onInputGosNumber"
                    ref="gosNumberInput"
                    class="field-upper-text"
                />
            </v-flex>
        </v-layout>
    </v-container>
</template>
<script>
    import helperMixin from '../../mixins/helper'
    import moment from 'moment';

    export default {
        mixins: [helperMixin],
        props: ['value'],
        data: function () {
            return {
                types: [
                    'Легковой',
                    'Автобус',
                    'Багги',
                    'Вездеход-амфибия',
                    'Грузовой',
                    'Картинг',
                    'Мотовездеход',
                    'Мотоцикл',
                    'Седельный тягач',
                    'Скутер',
                    'Снегоход',
                ],
                dateToday: null,
                flag: 0,
                placeholder: 'Гос. номер',
                placeholderDefault: 'Гос. номер',
                symbolsRussian: true,
                numberInfoLoading: false,
                formType: 'transport',
                fieldType: 'gosNumber',
                rules: {
                    required: v => !!v || 'Обязательное поле',
                    russianOnly: v => !(/[^А-Я0-9]/.test(v)) || 'Допускаются только русские буквы',
                    power: v => /^\d{1,4}$/.test(v) || 'Неверный формат',
                    maxMass: v => /^\d{4,5}$/.test(v) || 'Неверный формат',
                    seats: v => /^\d{1,3}$/.test(v) || 'Неверный формат',
                    vin: v => /^[\dABCDEFGHJKLMNPRSTUVWXYZ\*]{17}$/.test(v) ||
                        'Должен содержать 17 знаков. Не использовать I, O, Q',
                    bodyNumber: v => /^[\dABCDEFGHIJKLMNPQRSTUVWXYZ-]{6,24}$/.test(v) || 'Неверный формат',
                    chassisNumber: v => /^[\dABCDEFGHJKLMNPQRSTUVWXYZ-]{6,24}$/.test(v) || 'Неверный формат',
                    yearIssue: v => this.isYearValidRule(v),
                    number: v => /^[АВЕКМНОРСТУХ_\d\s]{4,}$/.test(v) || 'Неверный формат',
                    minCount: v => (v && v.replace(/(?!-)[^0-9А-Я]/g, "").length >= 8) || 'Введите номер автомобиля',
                    pts: v => /^\d{2}[\dА-ЯA-Z]{2} \d{6}$/.test(v) || 'Неверный формат',
                }
            }
        },

        methods: {
            isYearValidRule(year) {
                if (this.isInvalidYear(year)) {
                    return 'Неверно указан год выпуска';
                }
                return false;
            },
            isInvalidYear: function(year) {
                return year < 1930 || year > this.dateToday.slice(0,4);
            },
            vinOtoZeroAndUpperCase(value) {
                if (!value) return null;
                if (value.includes('*')) return
                this.value.vin = value.toString().toUpperCase().replace(/O/g, '0')
                return value;
            },
            stringToUpper: function(value) {
                if (!value) return null;
                return value.toString().toUpperCase();
            },
            onFocusTextField() {
                this.placeholder = 'А 123 АА 777'
            },

            onBlurTextField() {
                if (!this.gosNumber) {
                    this.placeholder = this.placeholderDefault
                } else {
                    this.placeholder = null
                }
            },

            onInputGosNumber(value) {
                let string = value.replace(/(?!-)[^a-zA-Z0-9а-яА-Я]/g, "")

                if (this.flag == 0) {
                    this.flag = 1
                    if( /[a-zA-Z]/.test(string)) {
                        this.symbolsRussian = false
                    } else {
                        this.symbolsRussian = true
                    }
                } else {
                    this.flag = 0
                }
                if (string == '' || value.slice(-1) == ' ') {
                    this.flag = 0
                }
                this.value.licensePlate = this.value.licensePlate.toUpperCase()
            },

            requestsByNumber() {
                if (!this.value.licensePlate) {
                    return
                }
                this.numberInfoLoading = true;

                try {
                    grecaptcha.ready(() => {
                        grecaptcha.execute(
                            Vue.GetpolisConstants.RECAPTCHA_SITEKEY,
                            {action: Vue.GetpolisConstants.RECAPTCHA_ACTIONS.TRANSPORT}
                        ).then(token => {
                            axios.post('/services/gettransport', {
                                    'r' : token,
                                    'formType' : this.formType,
                                    'type' : this.fieldType,
                                    'gosNumber': this.value.licensePlate.replace(/\s/g, '')
                                })
                                .then(response => {
                                    this.setTransportData({data: response.data, gosNumber: this.gosNumber})
                                })
                                .catch(error => {
                                    console.log(error)
                                }).finally(() => {
                                    this.numberInfoLoading = false;
                            })
                        })
                    })
                } catch (e) {
                    console.log(e);
                    this.numberInfoLoading = false;
                }
            },
            setTransportData(data) {
                if (data.gosNumber) {
                    this.value.licensePlate = data.gosNumber;
                }
                if (data.data) {
                    this.info = data.data;
                    if (this.info.vin) {
                        this.value.vin = this.info.vin;
                    }
                    if (this.info.body) {
                        this.value.bodyNumber = this.info.body;
                    }
                    if (this.info.chassis) {
                        this.value.chassisNumber = this.info.chassis;
                    }
                    if (this.info.chassis) {
                        this.value.chassisNumber = this.info.chassis;
                    }
                    if (this.info.color) {
                        this.value.color = this.info.color;
                    }
                    if (this.info.PTS && this.info.PTS.number) {
                        this.value.pts.seriesNumber = this.info.PTS.number;
                    }
                    if (this.info.STS && this.info.STS.number) {
                        this.value.sts.seriesNumber = this.info.STS.number;
                    }
                    if (this.info.year) {
                        this.value.yearIssue = this.info.year;
                    }
                    if (this.info.brand) {
                        this.value.mark = this.info.brand;
                    }
                    if (this.info.model) {
                        this.value.model = this.info.model;
                    }
                }
            },
        },

        created: function() {
            this.dateToday = this.fillDate = moment().format('YYYY-MM-DD')
        }
    }
</script>
<style>
    .service-transport-check-box >>> .v-input__control{
        height: 25px;
    }
    .service-transport-check-box.v-input--selection-controls.v-input .v-label{
        white-space: nowrap;
        margin-bottom: 0;
    }
</style>



// WEBPACK FOOTER //
// resources/js/components/services/ServiceTransportForm.vue